import { FC } from 'react';

import AppConfig from '../../../../config/AppConfig';
import Btn from '../../../../components/Button';
import Typography from '../../../../components/Typography';
import { gtmAttributesAccessPas } from '../../../../utils/gtmVariables';
import useGTMEventsTracker from '../../../../hooks/useGTMEventsTracker';

const Welcome: FC<any> = () => {
  const gtmEventsTracker = useGTMEventsTracker();
  const pasAccess = AppConfig.get('REACT_APP_LINK_CADASTRAR_SENHA');

  const accessPortal = () => {
    gtmEventsTracker(gtmAttributesAccessPas);
    if (pasAccess) {
      window.open(pasAccess, '_blank');
    } else {
      console.error('A variável de ambiente não está definida ou é inválida.');
    }
  };

  const message = (
    <>
      <Typography variant="body2" as="p" className="pt-4 text-neutral-darkest">
        A sua loja já está ativa no Portal do Lojista, o PAS. Agora basta{' '}
        <Typography variant="body2" as="b" className="font-semibold">
          cadastrar uma senha
        </Typography>{' '}
        e começar a vender!
      </Typography>
      <Typography variant="body2" as="p" className="pt-4 text-neutral-darkest">
        Ah, aproveite pra conferir os nossos treinamentos na Via Academy - Escola para Lojistas
      </Typography>
      <Typography variant="body2" as="p" className="pt-4 text-neutral-darkest">
        Boas vendas!
      </Typography>
    </>
  );

  return (
    <div className="w-full px-5 lg:w-[243px] lg:px-0">
      <div className="flex flex-col gap-10">
        <Typography
          variant="display1"
          as="h1"
          className="text-neutral-darkest text-2xl lg:text-4xl"
        >
          Boas-vindas!
        </Typography>
        <Typography variant="body2" as="div" className="w-full text-neutral-darkest flex flex-wrap">
          {message}
        </Typography>
        <div className="hidden lg:block w-60">
          <Btn text="Cadastrar senha" type="button" variant="primary" onClick={accessPortal} />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
